import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { AgenceEntity } from '../../../../entities/agence.entity';
import { PartenaireEntity } from '../../../../entities/partenaire.entity';
import { ORANGE } from '../../../../shared/colors';
import { createAgence } from '../network';

export const AgenceForm = ({
  partenaire,
  setShowDrawer,
  getNewAgence,
}: {
  partenaire: PartenaireEntity;
  setShowDrawer: (b: boolean) => void;
  getNewAgence: (age: AgenceEntity) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div>
      <Form
        layout='vertical'
        style={{ listStyleType: 'none' }}
        form={form}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        initialValues={{
          type: 'Banque',
        }}
        onFinish={async (data) => {
          setIsLoading(true);
          data.partenaire = partenaire.url;

          await createAgence(data).then(({ data, statusCode }) => {
            if (statusCode?.toString()[0] === '2') {
              notification.success({
                message: 'Succès',
                description: "L'agence a été créé avec succès",
              });
              getNewAgence(data);
              setShowDrawer(false);
            } else {
              notification.info({
                message: 'Erreur',
                description: data.message,
              });
            }
            setIsLoading(false);
          });
        }}
      >
        <Form.Item
          label="Nom de l'agence"
          name='nom'
          hasFeedback
          rules={[
            {
              required: true,
              message: "Entrez le nom de l'agence",
            },
          ]}
        >
          <Input placeholder="Entrez le nom de l'agence" />
        </Form.Item>
        <Form.Item
          label='Localisation'
          name='localisation'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez la localisation',
            },
          ]}
        >
          <Input placeholder='Entrez la localisation' />
        </Form.Item>
        <Form.Item
          label='Code référent'
          name='code'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le code référent',
            },
          ]}
        >
          <Input placeholder='Entrez le code référent' />
        </Form.Item>
        <Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            // size='large'
            loading={isLoading}
            style={{
              width: '50%',
              backgroundColor: ORANGE,
              borderWidth: 0,
              borderRadius: 5,
              marginBottom: 20,
            }}
          >
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
